import { ANALYTIC_PANEL_COLORS } from 'utils/constants/analyticPanelColors';

export enum CostSection {
    RENOVATION = 'renovation',
    PURCHASE_COSTS = 'purchaseCosts',
    OPERATING_COSTS = 'operatingCosts',
    SALE_COSTS = 'saleCosts',
    FINANCING_COSTS = 'financingCosts',
    OTHER_COSTS = 'otherCosts'
}

export const CostSectionLabels: Record<CostSection, string> = {
    [CostSection.RENOVATION]: 'Remont z materiałami',
    [CostSection.PURCHASE_COSTS]: 'Koszty okołozakupowe',
    [CostSection.OPERATING_COSTS]: 'Koszty eksploatacyjne',
    [CostSection.SALE_COSTS]: 'Koszty sprzedaży',
    [CostSection.FINANCING_COSTS]: 'Koszty finansowania',
    [CostSection.OTHER_COSTS]: 'Pozostałe koszty'
};

export const CostSectionColors: Record<CostSection, string> = {
    [CostSection.RENOVATION]: ANALYTIC_PANEL_COLORS.renovation,
    [CostSection.PURCHASE_COSTS]: ANALYTIC_PANEL_COLORS.purchaseCosts,
    [CostSection.OPERATING_COSTS]: ANALYTIC_PANEL_COLORS.operatingCosts,
    [CostSection.SALE_COSTS]: ANALYTIC_PANEL_COLORS.saleCosts,
    [CostSection.FINANCING_COSTS]: ANALYTIC_PANEL_COLORS.financingCosts,
    [CostSection.OTHER_COSTS]: ANALYTIC_PANEL_COLORS.otherCosts
};

export interface CostCardField {
    title: string;
    type?: 'text' | 'date' | 'string';
    fieldName: string;
    section?: CostSection;
    customColor?: string;
    value: string | number | null | undefined;
    totalValue?: string | number | null;
    helperText?: string;
    suffix?: string;
    totalValueSuffix?: string;
    showTotalValue?: boolean;
    placeholder?: string;
    valueLabel?: string;
    totalLabel?: string;
    required?: boolean;
    readOnly?: boolean;
    totalDisabled?: boolean;
    isFilterField?: boolean;
    isError?: boolean;
    errorMessage?: string;
}

export interface CostCardsGridProps {
    fields: CostCardField[];
    title?: string;
    showLegend?: boolean;
    showItemCount?: boolean;
    sectionColors?: Partial<Record<CostSection, string>>;
    sectionLabels?: Partial<Record<CostSection, string>>;
    onValueChange: (fieldName: string, value: string | number) => void;
    onValueBlur?: (fieldName: string, value: string | number) => void;
    onResetField?: (fieldName: string) => void;
    onResetTotalField?: (fieldName: string) => void;
    onTotalValueChange?: (fieldName: string, value: string | number) => void;
    onTotalValueBlur?: (fieldName: string, value: string | number) => void;
}

export interface CostsSummaryProps {
    totalCosts: number;
    projectBudget: number;
    estimatedProfitNetto?: number | null;
    roi?: number | null;
    margin?: number | null;
    onGenerateReport?: () => void;
    totalCostsLabel?: string;
    projectBudgetLabel?: string;
    profitLabel?: string;
    buttonLabel?: string;
}
